import { render, staticRenderFns } from "./TVplayPage.vue?vue&type=template&id=a8990aba&scoped=true"
import script from "./TVplayPage.vue?vue&type=script&lang=js"
export * from "./TVplayPage.vue?vue&type=script&lang=js"
import style0 from "./TVplayPage.vue?vue&type=style&index=0&id=a8990aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8990aba",
  null
  
)

export default component.exports